if (
  typeof Number !== undefined
  && Number.prototype
  && !Number.prototype.toHoursMinutesSeconds
) {
  Object.defineProperty(Number.prototype, 'toHoursMinutesSeconds', {
    value({
      includeMilliseconds = false,
      includeHours,
      includeHundrethsPlace = false
    } = {}) {
      let hrs = Math.floor(this / 3600);
      let min = Math.floor((this - (hrs * 3600)) / 60);
      let seconds = this - (hrs * 3600) - (min * 60);
      seconds = (includeHundrethsPlace) ? parseFloat(seconds * 100).toFixed(3) / 100 : Math.round(seconds * 100) / 100;
      let times = [];
      if (
        includeHours ||
        (
          includeHours !== false &&
          this >= 3600
        )
      ) {
        times.push((hrs < 10 ? '0' + hrs : hrs));
      }
      times.push((min < 10 ? '0' + min : min));
      times.push((seconds < 10 ? '0' + seconds : seconds));
      let joined = times.join(':');
      if (includeMilliseconds) {
        let suffix = includeHundrethsPlace ? '.000' : '.00';
        if (joined.includes('.')) {
          let idealLength;
          if (includeHours) {
            idealLength = includeHundrethsPlace ? 12 : 11;
          } else {
            idealLength = includeHundrethsPlace ? 9 : 8;
          }
          while (joined.length < idealLength) joined += '0';
          return joined;
        } else {
          return `${joined}${suffix}`;
        }
      } else {
        return joined.split('.')[0];
      }
    }
  });
}